"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _excluded = ["className", "bgColor", "style", "elevation", "children", "jss", "box", "square", "onTransitionEnd"];

var generateBoxShadowClasses = function generateBoxShadowClasses(elevations) {
  return elevations.reduce(function (acc, el, index) {
    acc["boxShadow".concat(index)] = {
      'box-shadow': el
    };
    return acc;
  }, {});
};

var useStyles = (0, _createStyles["default"])(function (theme) {
  return (0, _extends2["default"])({
    root: {
      borderRadius: 2,
      width: 'auto',
      transition: theme.transition.create('box-shadow')
    },
    bgColor: {
      backgroundColor: function backgroundColor(_ref) {
        var bgColor = _ref.bgColor;
        return bgColor;
      }
    },
    square: {
      borderRadius: 0
    },
    box: {
      border: "1px solid ".concat(theme.palette.border)
    }
  }, generateBoxShadowClasses(theme.boxShadow));
}, {
  name: 'Paper'
});
exports.useStyles = useStyles;

var Paper = /*#__PURE__*/_react["default"].forwardRef(function Paper(_ref2, ref) {
  var _cn;

  var _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      bgColor = _ref2.bgColor,
      _ref2$style = _ref2.style,
      style = _ref2$style === void 0 ? {} : _ref2$style,
      _ref2$elevation = _ref2.elevation,
      elevation = _ref2$elevation === void 0 ? 1 : _ref2$elevation,
      children = _ref2.children,
      _ref2$jss = _ref2.jss,
      jss = _ref2$jss === void 0 ? {} : _ref2$jss,
      _ref2$box = _ref2.box,
      box = _ref2$box === void 0 ? false : _ref2$box,
      _ref2$square = _ref2.square,
      square = _ref2$square === void 0 ? false : _ref2$square,
      onTransitionEnd = _ref2.onTransitionEnd,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var classes = useStyles({
    bgColor: bgColor,
    jss: jss
  });
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref,
    className: (0, _classnames["default"])(classes.root, (_cn = {}, (0, _defineProperty2["default"])(_cn, classes.bgColor, bgColor), (0, _defineProperty2["default"])(_cn, classes.box, box), (0, _defineProperty2["default"])(_cn, classes["boxShadow".concat(elevation)], !box), (0, _defineProperty2["default"])(_cn, classes.square, square), _cn), className),
    style: style,
    onTransitionEnd: onTransitionEnd
  }, props), children);
}); // Hack for withInfo plugin


Paper.displayName = 'Paper';
var _default = Paper;
exports["default"] = _default;